import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { X } from 'lucide-react';

const galleryImages = [
  {
    id: 1,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/6c0dv4a6_WGH%20Logo.jpg',
    alt: 'Wycheproof Grain Handling logo'
  },
  {
    id: 2,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/lfi7u4di_WGH%20Headquarters.jpg',
    alt: 'Wycheproof Grain Handling headquarters building'
  },
  {
    id: 3,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/kfdtmvy7_wheat%20crop.jpg',
    alt: 'Wheat crop ready for harvest'
  },
  {
    id: 4,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/86d5yu98_Bunker%20pic.jpeg',
    alt: 'Bunker operations at sunset'
  },
  {
    id: 5,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/66em27m3_Bunkers%20night.jpg',
    alt: 'Bunkers and silos at night'
  },
  {
    id: 6,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/1c65lbxq_Crop%20Pic.jpg',
    alt: 'Wheat crop close-up'
  },
  {
    id: 7,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/bbwmzkg7_FERT%20Pic%202.JPG',
    alt: 'Truck operations at sunset'
  },
  {
    id: 8,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/lm8is8lv_FERT%20Pic.JPG',
    alt: 'Grain storage silos at sunset with reflection'
  },
  {
    id: 9,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/z2s26dqy_Reach%20Stacker.jpg',
    alt: 'Reach stacker handling containers'
  },
  {
    id: 10,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/t4hc2vmp_S%26H%20Pic%202.JPG',
    alt: 'Grain outloading into truck'
  },
  {
    id: 11,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/dirun5z7_S%26H%20Pic.JPG',
    alt: 'Grain storage bunker operations'
  },
  {
    id: 12,
    src: 'https://customer-assets.emergentagent.com/job_vic-storage-depot/artifacts/j1nlev81_Truck%20unloading.JPG',
    alt: 'Truck unloading at silos'
  }
];

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-[#1a1a1a] py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Gallery</h1>
            <p className="text-gray-300 max-w-2xl mx-auto">
              Take a look at our facilities, operations, and the team that makes it all happen.
            </p>
          </div>
        </section>

        {/* Gallery Grid */}
        <section className="py-16">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {galleryImages.map((image) => (
                <div
                  key={image.id}
                  className="group relative overflow-hidden rounded-lg cursor-pointer bg-gray-100"
                  onClick={() => setSelectedImage(image)}
                >
                  <div className="aspect-[4/3]">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Want to See Our Facilities */}
        <section className="py-16 bg-[#faf8f5]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Want to See Our Facilities?</h2>
            <p className="text-gray-700 mb-6">
              Contact us to arrange a visit or to learn more about our operations at Wycheproof.
            </p>
            <a
              href="tel:+61354937444"
              className="inline-block px-8 py-3 bg-yellow-500 text-gray-900 font-semibold rounded-md hover:bg-yellow-400 transition-all duration-300"
            >
              Call +61 3 5493 7444
            </a>
          </div>
        </section>

        {/* Lightbox Modal */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
              onClick={() => setSelectedImage(null)}
            >
              <X size={32} />
            </button>
            <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="w-full h-auto max-h-[75vh] object-contain rounded-lg"
              />
              <p className="text-white text-center mt-4">{selectedImage.alt}</p>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default GalleryPage;
